export interface ResizeOptions {
  width?: number
  height?: number
  fit?: string
  dpr?: number
  quality?: number
}

const MC_STATIC_HOSTNAME = 'static.masterclass.com'
const CF_OPTIM_BASE_URL = 'https://www.masterclass.com/cdn-cgi/image/'

export const resizeImage = (url: string | null, opts: ResizeOptions) => {
  if (typeof url === 'string') {
    try {
      const newUrl = new URL(url)

      if (newUrl.hostname === MC_STATIC_HOSTNAME) {
        return mcStaticImgOptimization(url, opts)
      } else {
        return appendImgOptimizationUrlParams(newUrl, opts)
      }
    } catch (ex) {
      // eslint-disable-next-line no-console
      console.warn(ex)
      return url
    }
  }
  return undefined
}

const appendImgOptimizationUrlParams = (newUrl: URL, opts: ResizeOptions) => {
  Object.entries(opts).forEach(([key, value]) => {
    newUrl.searchParams.append(key, value)
  })
  return newUrl.toString()
}

const mcStaticImgOptimization = (src: string, opts: ResizeOptions) => {
  const params = Object.entries(opts).map(
    ([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
  )
  params.push(`format=webp/${encodeURIComponent(src.trim())}`)

  return `${CF_OPTIM_BASE_URL}${params.join(',')}`
}
